import React, { useRef, useEffect, useState } from "react";
import { Row, Col, Button, Spinner, OverlayTrigger, Tooltip, Modal } from "react-bootstrap";
import "./FlightCard.css";
import { FlightPopup, FlightInfoForm } from "../../index"
import line from "../../../../assets/images/flights/line-vertical.svg"
import baggageIcon from "../../../../assets/images/flights/streamline-flex_baggage.svg"
import handIcon from "../../../../assets/images/flights/fluent_money-hand-16-regular.svg"
import timeIcon from "../../../../assets/images/flights/formkit_time.svg"
import vector from "../../../../assets/images/flights/vector.svg"
import infoIcon from "../../../../assets/images/flights/fluent_info-24-regular.svg"
import ticketIcon from "../../../../assets/images/flights/heroicons_ticket.svg"
import takeoffIcon from "../../../../assets/images/flights/take.svg"
import dropIcon from "../../../../assets/images/flights/drop.svg"
import { useTranslation } from "../../../../contexts/TranslationContext";


export default function FlightCard({  url, data, onContinue, loading = false }) {
  const offers = data?.result?.offers || [];
  const { t } = useTranslation(); 
  const [showPopup, setShowPopup] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null);


  const handleShowPopup = (offer) => {
    setSelectedOffer(offer);
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setSelectedOffer(null);
  };

  const handleContinueFromPopup = (offerData) => {
    // Call the parent's onContinue function
    if (onContinue) {
      onContinue(offerData);
    }
    setShowPopup(false);
  };

  
  function getFlightDuration(departure, arrival) {
    const dep = new Date(departure);
    const arr = new Date(arrival);

    const diffMs = Math.abs(arr - dep);
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    return `${hours}H ${minutes}Min`;
  }

if (loading) {
  return (
    <div className="flight-listcard-container placeholder-glow p-3 rounded-4">
      <div className="flightlist-card d-flex justify-content-between align-items-center">
        <Col>
          <div className="mb-2">
            <div className="placeholder col-7 mb-2" style={{ height: 16 }} />
            <div className="placeholder col-5 mb-2" style={{ height: 12 }} />
          </div>
          <div className="d-flex gap-2 my-2 flex-wrap">
            <span
              className="badge bg-light text-light border placeholder col-2"
              style={{ height: 24 }}
            />
            <span
              className="badge bg-light text-light border placeholder col-3"
              style={{ height: 24 }}
            />
            <span
              className="badge bg-light text-light border placeholder col-2"
              style={{ height: 24 }}
            />
          </div>
          <div className="placeholder col-10 mb-1" style={{ height: 12 }} />
          <div className="placeholder col-9" style={{ height: 12 }} />
        </Col>
      </div>
    </div>
  );
}




  return (
    <div className="rounded-4  p-3 position-relative">
      {offers.map((offer, idx) => {
        const main = offer.mainjourny;
        const price_all_passengerers = offer.priceDetails?.totalAmount;
        const passengerFare = offer.passengerFareBreakdown || [];
        const price =
          passengerFare.find((p) => p.passengerTypeCode === "ADT")
            ?.passengerTotalAmount || passengerFare[0]?.passengerTotalAmount;
        const baggageInfo = offer.baggage_details || [];
        const baggageForADT =
          baggageInfo.find((b) => b.passengerType === "ADT") || baggageInfo[0];

        return (
          <div class="flight-listcard-container" key={idx}>
            <div class="flight-list-button-row">
              {offer.haveBundles && (
                <div className="flight-list-button-div">
                  <img src={ticketIcon} alt="" />
                  <span className="refundable-text">{t("HaveBundles")}</span>
                </div>
              )}

              {offer.canBeHeld && (
                <div className="flight-list-button-div">
                  <img src={timeIcon} alt="" />
                  <span className="refundable-text">{t("CanHold")}</span>
                </div>
              )}

              {offer.refundability && offer.refundability !== "UnKnown" && (
                <div className="flight-list-button-div">
                  <img src={handIcon} alt="" />
                  <span className="refundable-text">{t("Refundable")}</span>
                </div>
              )}
              <div className="baggage-div">
                <img src={baggageIcon} className="baggage-icon" alt="" />
                <span className="baggage-text">{t("Baggage")}</span>

                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-baggage-${offer.offerId}`}>
                      <div>
                        <b>{t("CarryOn")}:</b> {baggageForADT?.carryOnBaggage || "-"}{" "}
                        <br />
                        <b>{t("CheckIn")}:</b> {baggageForADT?.checkInBaggage || "-"}
                      </div>
                    </Tooltip>
                  }
                >
                  <img src={infoIcon} className="info-icon" alt="" />
                </OverlayTrigger>
              </div>
            </div>
            <div className="flightlist-card">
              <div className="trip-info">
                {/* FROM */}
                <div className="city city-from">
                  <div className="takeoff-div">
                    <span className="airport-code">{main.origin}</span>
                    <span className="city-name">
                      {main.departureTerminal
                        ? `Terminal ${main.departureTerminal}`
                        : ""}
                    </span>
                  </div>
                  <div className="takeoff-div">
                    <img src={takeoffIcon} alt="" className="take-off-icon" />
                    <span className="time">
                      {new Date(main.departureDateTime).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </span>
                  </div>
                  <div className="time-info flight-list-date">
                    {new Date(main.departureDateTime).toLocaleDateString()}
                  </div>
                </div>

                {/* FLIGHT INFO */}
                <div className="flight-info">
                  <div className="line-before">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="101"
                      height="1"
                      viewBox="0 0 101 1"
                      fill="none"
                    >
                      <path
                        d="M-0.00244141 0.504883H101.003"
                        stroke="#B7B7B7"
                        strokeDasharray="2 2"
                      />
                    </svg>
                  </div>
                  <div className="flight-duration">
                    <span className="airport-name">
                      {getFlightDuration(
                        main.departureDateTime,
                        main.arrivalDateTime
                      )}{" "}
                      |{" "}
                      {main.numberOfStops === 0
                        ? "Direct Flight"
                        : `${main.numberOfStops} Stop(s)`}
                    </span>
                  </div>
                  <div className="line-before">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="101"
                      height="6"
                      viewBox="0 0 101 6"
                      fill="none"
                      className="line-before-svg"
                    >
                      <path
                        d="M101.005 3L96.005 0.113249V5.88675L101.005 3ZM0 3V3.5H1.01005V3V2.5H0V3ZM3.03015 3V3.5H5.05025V3V2.5H3.03015V3ZM7.07035 3V3.5H9.09044V3V2.5H7.07035V3ZM11.1105 3V3.5H13.1306V3V2.5H11.1105V3ZM15.1507 3V3.5H17.1708V3V2.5H15.1507V3ZM19.1909 3V3.5H21.211V3V2.5H19.1909V3ZM23.2311 3V3.5H25.2512V3V2.5H23.2311V3ZM27.2713 3V3.5H29.2914V3V2.5H27.2713V3ZM31.3115 3V3.5H33.3316V3V2.5H31.3115V3ZM35.3517 3V3.5H37.3718V3V2.5H35.3517V3ZM39.3919 3V3.5H41.412V3V2.5H39.3919V3ZM43.4321 3V3.5H45.4522V3V2.5H43.4321V3ZM47.4723 3V3.5H49.4924V3V2.5H47.4723V3ZM51.5125 3V3.5H53.5326V3V2.5H51.5125V3ZM55.5527 3V3.5H57.5728V3V2.5H55.5527V3ZM59.5929 3V3.5H61.613V3V2.5H59.5929V3ZM63.6331 3V3.5H65.6532V3V2.5H63.6331V3ZM67.6733 3V3.5H69.6934V3V2.5H67.6733V3ZM71.7135 3V3.5H73.7336V3V2.5H71.7135V3ZM75.7537 3V3.5H77.7738V3V2.5H75.7537V3ZM79.7939 3V3.5H81.814V3V2.5H79.7939V3ZM83.8341 3V3.5H85.8542V3V2.5H83.8341V3ZM87.8743 3V3.5H89.8944V3V2.5H87.8743V3ZM91.9145 3V3.5H93.9346V3V2.5H91.9145V3ZM95.9547 3V3.5H97.9748V3V2.5H95.9547V3Z"
                        fill="#B7B7B7"
                      />
                    </svg>
                  </div>
                </div>

                {/* TO */}
                <div className="city city-to">
                  <div className="takeoff-div">
                    <span className="airport-code">{main.destination}</span>
                    <span className="city-name">
                      {main.arrivalTerminal
                        ? `Terminal ${main.arrivalTerminal}`
                        : ""}
                    </span>
                  </div>
                  <div className="takeoff-div">
                    <img src={dropIcon} alt="" className="drop-icon"/>
                    <span className="time">
                      {new Date(main.arrivalDateTime).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </span>
                  </div>
                  <div className="time-info flight-list-date">
                    {new Date(main.arrivalDateTime).toLocaleDateString()}
                  </div>
                </div>
              </div>

              <img src={line} className="divider-line" />

              {/* PRICE */}
              <div className="flight-component">
                <div className="price-row">
                  <div className="flight-component-text">{t("BasicEco")}</div>
                  <div>
                    <span className="price">
                      {price?.amount.toFixed(2)} {price?.currency}
                    </span>
                    <img src={infoIcon} alt="" />
                  </div>
                </div>

                <div className="price-total-row"  >
                  <div className="price-total" >
                   Total
                  </div>
                  <div>
                    <span className="price-total" >
                      {price_all_passengerers?.amount.toFixed(2)}{" "}
                      {price_all_passengerers?.currency}
                    </span>
                  </div>
                </div>
                <div className="ticket-row">
                  <button 
                    className="view-btn-flight"
                    onClick={() => handleShowPopup(offer)}
                  >
                    {t("Select")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })}

      {/* Flight Popup Modal */}
      <Modal 
        show={showPopup} 
        onHide={handleClosePopup} 
        size="lg"
        centered
        className="flight-popup-modal"
      >
        <Modal.Header closeButton>
       
        </Modal.Header>
        <Modal.Body>
          <FlightPopup url={url} offer={selectedOffer} onContinue={handleContinueFromPopup} />
        </Modal.Body>
       
      </Modal>


      
    </div>
  );
}